// src/redux/sagas/SourcingSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
    fetchAllApplicantsStart,
    fetchAllApplicantsSuccess,
    fetchAllApplicantsFailure,
    getNotesStart,
    getNotesSuccess,
    getNotesFailure,
} from "../recruitmentSourcing/SourcingSlice";
import { fetchAllApplicantsApi ,fetchNoteApi} from "../recruitmentSourcing/SourcingApi";
import { showToast } from "../../../components";

function* fetchAllApplicantsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};
    const response = yield call(fetchAllApplicantsApi, params);

    if (response?.data) {
      const applicantsData = response.data.data || [];

      yield put(
        fetchAllApplicantsSuccess({
          data: applicantsData,
          total: response.data.total || applicantsData.length || 0,
        })
      );

      // optional success callback
      if (onSuccess) onSuccess(applicantsData);
    } else {
      yield put(fetchAllApplicantsFailure("Failed to fetch applicants"));
      // showToast("Failed to fetch applicants", "error", 2000);
    }
  } catch (error) {
    yield put(fetchAllApplicantsFailure(error.message));
    showToast(error.message || "Failed to fetch applicants", "error", 2000);
  }
}

function* fetchNotesWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload || {};
    const response = yield call(fetchNoteApi, params);

    if (response?.data) {
      const notesData = response.data.data || [];

      yield put(
        getNotesSuccess({
          data: notesData,
          total: response.data.total || notesData.length || 0,
        })
      );

      // optional callback on success
      if (onSuccess) onSuccess(notesData);
    } else {
      yield put(getNotesFailure("Failed to fetch notes"));
      showToast("Failed to fetch notes", "error", 2000);
    }
  } catch (error) {
    yield put(getNotesFailure(error.message));
    showToast(error.message || "Failed to fetch notes", "error", 2000);
  }
}


export function* watchSourcing() {
  yield takeLatest(fetchAllApplicantsStart.type, fetchAllApplicantsWorker);
   yield takeLatest(getNotesStart.type, fetchNotesWorker);
}
